// extracted by mini-css-extract-plugin
module.exports = {"container":"W-5IKVuMI0ixEShwGqlN5w==","button":"_72s6+egJy1CLUOn79oNxqw==","icon":"_7Z3jgydB+k8LQccOM5pAZQ==","description":"_7mme1wGAXzrlGWyQYf-vkw=="};